import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Header.css';
//import Confetti from 'react-confetti';

function Header() {
  const [open, setOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);



/*const messages = [
  "🎉 Crystal Drops @ 10 — A Decade of Celebration 🎉",
  "🥂 Cheers to 10 Years of Progress 🥂",
  "🎊 Honoring 10 Years of Excellence 🎊",
  "✨ A Decade of Innovation & Growth ✨"
];

 // const [index, setIndex] = useState(0);
 // const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false); // start fade-out
      setTimeout(() => {
        setIndex((prevIndex) => (prevIndex + 1) % messages.length);
        setFade(true); // fade-in new message
      }, 500); // fade duration
    }, 15000); // change every 15 seconds

    return () => clearInterval(interval);
  }, [messages.length]);*/

  function closeNav() {
    setOpen(false);
  }
  function closeDropdown() {
    setServicesOpen(false);
  }

  return (
    <header className="site-header">
      <div className="header-inner">
        {/* Logo */}
        <NavLink className="brand" to="/" onClick={closeNav}>
          <img src="/images/crystaldrops.png" alt="Crystal Drops" className="brand-logo" />
        </NavLink>

        {/* Hamburger Toggle */}
        <button
          className="nav-toggle"
          aria-label="Toggle navigation"
          aria-expanded={open}
          onClick={() => setOpen(!open)}
        >
          <span className="hamburger" />
          <span className="sr-only">Menu</span>
        </button>

        {/* Navigation */}
        <nav className={`site-nav ${open ? 'open' : ''}`}>
          <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''} onClick={closeNav}>
            Home
          </NavLink>
          <NavLink to="/about" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeNav}>
            About
          </NavLink>

          {/* Services Dropdown */}
          <div
            className={`dropdown ${servicesOpen ? 'open' : ''}`}
            onMouseEnter={() => setServicesOpen(true)}
            onMouseLeave={() => setServicesOpen(false)}
          >
            <NavLink
              to="/services"
              className={({ isActive }) => `dropdown-toggle ${isActive ? 'active' : ''}`}
              aria-haspopup="true"
              aria-expanded={servicesOpen}
              aria-controls="services-menu"
              onClick={closeNav}
            >
              Services ▾
            </NavLink>

            <ul id="services-menu" className="dropdown-menu">
              <li><NavLink to="/WTP" onClick={() => { closeDropdown(); closeNav(); }}>Water Treatment Plant</NavLink></li>
              <li><NavLink to="/FRP" onClick={() => { closeDropdown(); closeNav(); }}>FRP-Pressure Sand Filter</NavLink></li>
              <li><NavLink to="/IDS" onClick={() => { closeDropdown(); closeNav(); }}>Industrial/Domestic Softeners-FRP/MS</NavLink></li>
              <li><NavLink to="/STP" onClick={() => { closeDropdown(); closeNav(); }}>Sewage Treatment Plant</NavLink></li>
              <li><NavLink to="/PSF" onClick={() => { closeDropdown(); closeNav(); }}>Pressure Sand Filter & Activated Carbon Filter</NavLink></li>
              <li><NavLink to="/ETP" onClick={() => { closeDropdown(); closeNav(); }}>Effluent Treatment Plant</NavLink></li>
              <li><NavLink to="/UF" onClick={() => { closeDropdown(); closeNav(); }}>Ultra Filtration</NavLink></li>
              <li><NavLink to="/RO" onClick={() => { closeDropdown(); closeNav(); }}>Skid Mounted Reverse Osmosis Plant</NavLink></li>
            </ul>
          </div>

          <NavLink to="/gallery" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeNav}>
            Gallery
          </NavLink>
          <NavLink to="/contact" className={({ isActive }) => isActive ? 'active' : ''} onClick={closeNav}>
            Contact
          </NavLink>
        </nav>
      </div>

      {/* Rotating Anniversary Banner with fade */}
      {/*<div className="anniversary-banner">
        <div className={`marquee ${fade ? 'fade-in' : 'fade-out'}`}>
          <span>{messages[index]}</span>
        </div>
      </div>
      <Confetti
        numberOfPieces={200}
        recycle={true}
        gravity={0.2}
        wind={0.01}
      />*/}
    </header>
  );
}

export default Header;